const getThreadType = (threadMeta) => {
  return String(threadMeta?.threadType || threadMeta?.thread_type || '')
    .trim()
    .toLowerCase();
};

export default getThreadType;
